import {useContext, useState,useRef} from 'react'
import {  LanguageContext } from '../../context';
import Translate from '../Translate/Translate';
import { Link } from 'react-router-dom';
import './Navigation.css'
import deleteIcon from "../../Images/Header/delete.svg"

const Navigation = () => {

    const { language } = useContext(LanguageContext);
    const [classNavSection,setClassNavSection]=useState('navigate-menu close');
    const [isOpen,setIsOpen]=useState('open');
    const refClose=useRef(null);
    const refMenu=useRef(null);
    
    const  handleToggle=()=>{        
        setIsOpen(isOpen=='close'?'open':'close')
        setClassNavSection(`navigate-menu ${isOpen}`);
        if(isOpen=='close'){
            refMenu.current.focus();
        }
        else{
            refClose.current.focus();
          }
    }

    const handleEnter=(e)=>{
       if(e.keyCode==13){
        handleToggle();
       }
        
    }

    const handleClose=()=>{
        refClose.current.focus();
      }

  return (
    <div className='navigation-container'>
        <span className='hamburger-icon' role="button" aria-haspopup="true" aria-expanded="false" aria-label="פתיחת תפריט" tabIndex="0" ref={refMenu}
                 onKeyUpCapture={handleEnter} onClick={handleToggle}>&#9776;</span>
        <div className={classNavSection}> 
       
        <ul>
        <div ><a href="javascript:void(0)" role="listitem" className='close-button' aria-label="סגור תפריט" ref={refClose} onClick={handleToggle}>
                <img src={deleteIcon} alt="close" /></a></div>
            <li> <Link to={`/${language}/about`}><Translate>About</Translate></Link></li>
            <li><Link to={`/${language}/developer`}><Translate>Developer</Translate></Link></li>
            <li> <Link to={`/${language}/accessibility`}><Translate>Accessibility</Translate></Link> </li>
            <li className='offset lastDivClose' tabIndex="0" onBeforeInput={handleClose} onFocus={handleClose}><Translate>MustCloseSection</Translate></li>	       
             </ul>


           
            
                 
        </div>
    </div>
  )
}

export default Navigation